import * as React from "react";
const SvgFiRrDuck = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-duck_svg__a)">
      <path
        fill="#062147"
        d="M14.54 19.994c-.07 0 .07.004 0 0m2.768-5.884a3.47 3.47 0 0 1 .935 2.631c-.125 1.832-1.765 3.253-3.702 3.253-1.889-.1-3.642-.965-4.629-1.516a1.774 1.774 0 0 1-.202-2.979c1.254-.95 3.3-2.499 5.041-2.499.966 0 1.896.405 2.557 1.11m-1.461 1.366A1.49 1.49 0 0 0 14.75 15c-1.069 0-2.543 1.116-3.57 1.895.882.491 1.885 1.024 3.256 1.097.833.041 1.751-.502 1.811-1.386a1.5 1.5 0 0 0-.4-1.13M24 6.25c0 .451-.28.855-.702 1.013l-2.755 1.033a6 6 0 0 1-.87 1.463c1.307 1.41 3.326 4.327 3.326 6.941 0 4.741-3.815 7.3-7.406 7.3H8.649C3.676 24 .12 20.721.003 16.025c-.026-1.078.174-3.451.547-4.716a1.8 1.8 0 0 1 1.528-1.295c.724-.09 1.444.26 1.818.894.083.139.171.301.265.475.285.525.878 1.617 1.306 1.617 1.065 0 3.172-1.674 4.741-3.393A5.97 5.97 0 0 1 9 6c0-3.309 2.691-6 6-6a6.01 6.01 0 0 1 5.749 4.281l2.549.956c.422.158.702.562.702 1.013M11 6c0 2.206 1.794 4 4 4s4-1.794 4-4-1.794-4-4-4-4 1.794-4 4m7.179 5.086A5.96 5.96 0 0 1 15 12a5.97 5.97 0 0 1-3.342-1.019C10.47 12.271 7.695 15 5.467 15c-1.619 0-2.523-1.667-3.099-2.729-.239 1.103-.386 2.895-.365 3.704.09 3.603 2.761 6.024 6.646 6.024h6.944c2.173 0 5.406-1.412 5.406-5.3 0-1.946-1.7-4.432-2.82-5.614z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-duck_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrDuck;
